import type { FunctionComponent } from 'react'
import React from 'react'

export const Body: FunctionComponent<Props> = ({ children }) => <tbody>{children}</tbody>

///////// IMPLEMENTATION /////////

type Props = {
  children: React.ReactNode
}
